
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","width":"36","height":"36","rx":"5","fill":"#56BFC7"}}),_c('path',{attrs:{"d":"M26.115 27H12.961a2.077 2.077 0 010-4.154h11.77a1.384 1.384 0 001.384-1.384V10.385A1.385 1.385 0 0024.731 9H12.96a2.077 2.077 0 00-2.077 2.021v13.847M24.73 22.846V27","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    